import React, { useState, useEffect } from 'react'
import SectionDrop from './SectionDrop'
import FormSelect from './FormSelect'
import FormInput from './FormInput'
import styled, { css } from 'styled-components'
import Sticky from 'react-sticky-el'

function Calculator() {
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState({})
  const [filterTexture, setFilterTexture] = useState([])
  const [filterPlaster, setFilterPlaster] = useState([])
  const [filterBrand, setFilterBrand] = useState([])
  const [filterBrandWarming, setFilterBrandWarming] = useState([])
  const [filterThickness, setFilterThickness] = useState([])
  const [categoriesList, setCategoriesList] = useState([])

  const [typeFinishLayer, setTypeFinishLayer] = useState(null)
  const [areaFilter, setAreaFilter] = useState(null)
  const [cart, setCart] = useState([])

  useEffect(() => {
    fetch('https://tvoydom.by/calculator_data')
      .then(res => res.json())
      .then(
        result => {
          console.log(result, 'res')
          setData(result)
          setFilterTexture((result.texture.length !== 0 && result.texture[0].value) || [])
          setFilterPlaster((result.plaster.length !== 0 && result.plaster[0].value) || [])
          setFilterBrand((result.brands.length !== 0 && result.brands[0].value) || [])
          setFilterBrandWarming(
            (result.brandsWarming.length !== 0 && result.brandsWarming[0].value) || [],
          )
          setFilterThickness((result.thickness.length !== 0 && result.thickness[0].value) || [])
          setCategoriesList((result.categories.length !== 0 && result.categories) || [])
          setIsLoading(false)
        },
        error => {
          console.log(error, 'err')
        },
      )
  }, [])

  const createOrder = async cart => {
    const url = 'https://tvoydom.by/calculator_create_order'

    const requestOptions = {
      method: 'POST',
      body: JSON.stringify(cart),
      headers: { 'Content-Type': 'application/json' },
    }

    try {
      const response = await fetch(url, requestOptions)
      console.log('response', response)
      window.location.replace('/cart')
    } catch (error) {
      console.error('Ошибка:', error)
    }
  }

  const { texture, plaster, brands, brandsWarming, thickness } = data || {}

  const handleAreaFilter = e => {
    setAreaFilter(e)
    setCart([])
  }

  const handleFilterBrandsWarming = val => {
    setFilterBrandWarming(val)
    setCart(cart.filter(el => el.category_id != 3))
  }

  const handleFilterPlaster = val => {
    setFilterPlaster(val)
    setCart(cart.filter(el => el.category_id != 7))
  }

  const handleFilterTexture = val => {
    setFilterTexture(val)
    setCart(cart.filter(el => el.category_id != 7))
  }

  const handleFilterBrands = val => {
    setFilterBrand(val)
    setCart([])
  }

  const handleFilterThicknes = val => {
    setFilterThickness(val)
    setCart([])
  }

  const handleCart = val => {
    setCart(val)
  }

  const dataSection = (categoryId, products) => {
    const filterByCategory = [...products]
    if (
      filterBrand != 'all' &&
      (categoryId == 1 || categoryId == 2 || categoryId == 5 || categoryId == 6)
    ) {
      return filterByCategory.filter(product => product.brand === filterBrand)
    } else if (categoryId == 3) {
      let arr = filterByCategory
      if (filterBrandWarming != 'all')
        arr = arr.filter(product => product.brand === filterBrandWarming)

      if (filterThickness != 'all')
        arr = arr.filter(product => product.thickness === filterThickness)

      return arr
    } else if (categoryId == 4) {
      let arr = filterByCategory

      if (filterThickness != 'all') {
        arr = arr.filter(product => product.thickness == filterThickness)
      }

      return arr
    } else if (categoryId == 7) {
      let arr = filterByCategory

      if (!typeFinishLayer) {
        return []
      }

      arr = arr.filter(product => product.type === typeFinishLayer)

      if (filterBrand != 'all') {
        arr = arr.filter(product => product.brand === filterBrand)
      }

      if (filterTexture != 'all') {
        arr = arr.filter(product => product.texture === filterTexture)
      }

      if (filterPlaster != 'all') {
        arr = arr.filter(product => product.plaster === filterPlaster)
      }

      return arr
    } else return filterByCategory
  }

  const handleRadioFilters = val => {
    setTypeFinishLayer(val)
    setCart(cart.filter(el => el.category_id != 7))
  }

  const totalPrice = () => {
    if (cart.length != 0) {
      const result = cart
        .map(el => el.totalPrice)
        .reduce((acc, cur) => {
          return acc + cur
        })
      return result
    } else return 0
  }

  const renderChildren = id => {
    if (id == 3) {
      return (
        <SectionDropData>
          <FormSelect
            options={brandsWarming}
            value={filterBrandWarming}
            onChange={handleFilterBrandsWarming}
            label="Выбрать производителя"
          />
        </SectionDropData>
      )
    } else if (id == 7) {
      return (
        <SectionDropData modif="finishLayout">
          <FilterWrap modif="finishLayout">
            <FilterCell modif="full">
              <RadioBtn
                active={typeFinishLayer == 'finish'}
                onClick={() => handleRadioFilters('finish')}
              >
                Готовые штукатурки (не требующие окраски)
              </RadioBtn>
            </FilterCell>
            <FilterCell modif="full">
              <RadioBtn
                active={typeFinishLayer == 'mineral'}
                onClick={() => handleRadioFilters('mineral')}
              >
                Минеральные штукатурки (под окраску)
              </RadioBtn>
            </FilterCell>
            <FilterCell modif="finish">
              <FormSelect
                options={texture}
                value={filterTexture}
                onChange={handleFilterTexture}
                label="Выберите вид связующего"
              />
            </FilterCell>
            <FilterCell modif="finish">
              <FormSelect
                options={plaster}
                value={filterPlaster}
                onChange={handleFilterPlaster}
                label="Выберите фактуру"
              />
            </FilterCell>
          </FilterWrap>
        </SectionDropData>
      )
    } else return null
  }

  if (isLoading) return null
  return (
    <div className="calculator">
      <Top>
        <FilterWrap>
          <FilterCell>
            <FormSelect
              options={thickness}
              value={filterThickness}
              onChange={handleFilterThicknes}
              label="Толщина утеплителя, мм"
            />
            <Link href="#">Заказать расчёт</Link>
          </FilterCell>
          <FilterCell>
            <FormInput
              label="Площадь утепления, м. кв."
              type="price"
              value={areaFilter}
              onChange={handleAreaFilter}
            />
            <Link href="#">Заказать замер</Link>
          </FilterCell>
          <FilterCell>
            <FormSelect
              options={brands}
              value={filterBrand}
              onChange={handleFilterBrands}
              label="Производитель/Бренд"
            />
          </FilterCell>
        </FilterWrap>

        {!!totalPrice() && (
          <div className="sticky">
            <Sticky className="stickyWrap">
              <TotalPrice>
                Общая сумма: <br /> {totalPrice().toFixed(2)} BYN
              </TotalPrice>
            </Sticky>
          </div>
        )}
      </Top>
      {categoriesList.length != 0 &&
        categoriesList.map((category, idx) => (
          <SectionWrap key={category.id || idx}>
            <SectionDrop
              id={category.id}
              title={category.title}
              description={category.description}
              products={dataSection(category.id, category.products)}
              cart={cart}
              filters={{
                areaFilter: areaFilter,
                filterBrand: filterBrand,
                filterThickness: filterThickness,
                filterTexture: filterTexture,
                filterPlaster: filterPlaster,
                typeFinishLayer: typeFinishLayer,
              }}
              handleCart={handleCart}
              hideTable={category.id == 7 && !typeFinishLayer}
              withThoTable={category.id == 5 || (category.id == 7 && typeFinishLayer == 'mineral')}
            >
              {renderChildren(category.id)}
            </SectionDrop>
          </SectionWrap>
        ))}
      <AddToCartWrap>
        <AddToCart onClick={() => createOrder(cart)} disabled={cart.length == 0}>
          Положить систему в корзину
        </AddToCart>
      </AddToCartWrap>
    </div>
  )
}

export default Calculator

const SectionDropData = styled.div`
  width: 100%;
  max-width: 200px;

  ${p =>
    p.modif == 'finishLayout' &&
    css`
      max-width: 500px;
    `}
`
const SectionWrap = styled.div`
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`
const FilterWrap = styled.div`
  padding-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;

  @media (max-width: 1199px) {
    padding-top: 35px;
  }

  ${p =>
    p.modif == 'finishLayout' &&
    css`
      padding-bottom: 0;
      padding-top: 0 !important;
    `}
`
const FilterCell = styled.div`
  padding: 0 15px 30px 15px;
  min-width: 250px;

  ${p =>
    p.modif == 'full' &&
    css`
      max-width: 100%;
      width: 100%;
    `}

  ${p =>
    p.modif == 'finish' &&
    css`
      max-width: 100%;
      width: 50%;
      padding-bottom: 15px;
    `}
`
const Top = styled.div`
  display: flex;
  flex-wrap: wrap;
`
const TotalPrice = styled.div`
  flex: 1;
  padding-left 20px;
  text-align: right;
  font-weight: bold;
  font-size: 20px;
  line-height: 33px;
  color: #333333;
  display: inline-block;
  padding: 20px 25px;
  background: #FFFFFF;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.05);
  border-radius: 0px 0px 0px 5px;
  z-index: 1111;
  position: relative;

  br {
    display: none;
  }

  @media (max-width: 767px) {
    flex: none;
    width: 100%;
    text-align: center;

    br {
      display: block;
    }
}

`
const Link = styled.a`
  display: inline-block;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  text-decoration-line: underline;
  color: #acacac;
  margin-top: 6px;
  transition: 0.3s;

  &:hover {
    opacity: 0.8;
    color: inherit;
  }
`
const RadioBtn = styled.div`
  font-weight: bold;
  font-size: 14px;
  color: #333333;
  position: relative;
  padding-left: 25px;
  transition: 0.3s;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 3px;
    border: 1px solid #b5b5b5;
    width: 16px;
    height: 16px;
    border-radius: 8px;
    transition: 0.3s;
  }

  ${p =>
    p.active &&
    css`
      pointer-events: none;

      &:before {
        border: 5px solid #3b99fc;
      }
    `}
`
const AddToCartWrap = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px;
`
const AddToCart = styled.button`
  border: 1px solid #ea5e61;
  background: #ea5e61;
  border-radius: 4px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  padding: 10px 25px;
  transition: 0.3s;
  outline: none;

  &:hover {
    opacity: 0.8;
  }

  ${p =>
    p.disabled &&
    css`
      opacity: 0.8;
      pointer-events: none;
      background: rgb(195, 195, 195);
      border-color: rgb(195, 195, 195);
    `}
`
